<!--
 * @Author: 朱占伟
 * @LastEditors: 邱扬
 * @description: 公共底部
 * @Date: 2021-07-23 18:23:00
 * @LastEditTime: 2022-01-04 15:36:24
-->
<template>
  <div class="footer">
    <van-tabbar
      v-model="active"
      class="pt-5 tabar-box"
      :active-color="navConfig.activeColor"
      :inactive-color="navConfig.inactiveColor"
      :route="navConfig.route"
    >
      <van-tabbar-item v-for="item in nav" :key="item.name" class="tabbar-item" :to="item.path">
        <template v-if="item.className" #icon="" class="text-center">
          <i :class="item.className" />
          <h5 class="navName">
            {{ item.name }}
          </h5>
        </template>
        <template v-else #icon="" class="text-center">
          <div class="campaign-icon">
            <img :src="imgSrc">
          </div>
          <div class="posH" />
          <h5 class="navName">
            {{ item.name }}
          </h5>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { ref,onMounted } from 'vue';
import { nav } from './data';
import { useRouter } from 'vue-router';
import imgSrc from 'assets/images/icon/campagn.svg'
export default {
  setup() {
    const navConfig = {
      route: true,
      activeColor: '#6153ff',
      inactiveColor: '#999'
    };
    const active = ref(0);
    //跳转子路由时仍然保持tabbar激活状态
    const router=useRouter()

    const currentPath=router.currentRoute.value.path

    onMounted(()=>{
      const tabbar=document.querySelectorAll('.tabbar-item')
      if(currentPath.indexOf('/home')!==-1){
        tabbar[0].style.color="#6153ff"
      }else if(currentPath.indexOf('/order')!==-1){
        tabbar[1].style.color="#6153ff"
      }else if(currentPath.indexOf('/campaign')!==-1){
        tabbar[2].style.color="#6153ff"
      }else if(currentPath.indexOf('/service')!==-1){
        tabbar[3].style.color="#6153ff"
      }else if(currentPath.indexOf('/mine')!==-1){
        tabbar[4].style.color="#6153ff"
      }
    })

    return {
      active,
      navConfig,
      nav,
      imgSrc
    };
  }
};
</script>
<style lang="scss" scoped>
.footer {
  .tabar-box {
    box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  }

  .posH {
    height: 19px;
    visibility: hidden;
  }

  .campaign-icon {
    position: absolute;
    bottom: 16px;
    left: 2px;
    z-index: 99;
    padding: 4px;
    box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
    border-radius: 50%;

    :deep(img) {
      height: auto !important;
    }
  }
}

.icon-xiadan-self {
  color: $main;
}

.navName {
  font-size: 12px;
  padding: 4px 0;
  font-weight: 400;
}
</style>

